export default {
	namespaced: true,
	state: {
		translater: undefined
	},
	getters: {
		translater(state)
		{
			return state.translater
		}
	},

	actions: {
		translater(context, payload)
		{
			context.commit('translater', payload)
		}
	},

	mutations: {
		translater(state, payload)
		{
			state.translater = payload;
			
		}
	}
}